import { BOARD_W, BOARD_H, isLegacyImage, legacyImageOf, strokesOf } from './Whiteboard.jsx';

// A saved sketch, replayed read-only: what the client sees on the view link,
// and what the printer gets.
//
// Deliberately SVG rather than a canvas. Replaying the same stroke list into a
// canvas would just rebuild the 1568px bitmap we stopped storing, and print it
// soft. Polylines have no resolution, so the drawing comes off the printer at
// the printer's resolution and scales to whatever the client's screen is.
//
// A board from before strokes were saved is a picture, and is shown as one.
// It is never dropped from the view link or the print for being old.

export default function SketchView({ sketch, label, className, guide = null }) {
  if (isLegacyImage(sketch)) {
    return <img className={className} src={sketch} alt={label} />;
  }
  const strokes = strokesOf(sketch);
  const legacy = legacyImageOf(sketch);
  if (!strokes.length && !legacy) return null;
  const w = sketch.w || BOARD_W;
  const h = sketch.h || BOARD_H;

  return (
    <svg
      className={className}
      viewBox={`0 0 ${w} ${h}`}
      role="img"
      aria-label={label}
      preserveAspectRatio="xMidYMid meet"
    >
      <rect x="0" y="0" width={w} height={h} fill="#fff" />
      {/* A legacy picture was drawn on a plain white board, so no ruling goes
          over it: the figures would land on top of the old drawing. */}
      {legacy ? <image href={legacy} x="0" y="0" width={w} height={h} /> : guide}
      {strokes.map((stroke, i) => {
        const pts = stroke && Array.isArray(stroke.p) ? stroke.p : [];
        if (!pts.length) return null;
        // A tap is one point. Repeat it so the round cap draws a dot rather
        // than a path with nowhere to go.
        const drawn = pts.length === 1 ? [pts[0], pts[0]] : pts;
        return (
          <polyline
            key={i}
            points={drawn.map(p => `${p[0]},${p[1]}`).join(' ')}
            fill="none"
            stroke={stroke.c || '#1a2040'}
            strokeWidth={stroke.w || 3.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        );
      })}
    </svg>
  );
}
